// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"castle-7"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 3C14.7614 3 17 5.23858 17 8V9H21V21H3V9H7V8C7 5.23858 9.23858 3 12 3Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M18 13C19.6569 13 21 14.3431 21 16V21H3V16C3 14.3431 4.34315 13 6 13C7.65685 13 9 14.3431 9 16C9 14.3431 10.3431 13 12 13C13.6569 13 15 14.3431 15 16C15 14.3431 16.3431 13 18 13Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9 21V16M9 21H3V16C3 14.3431 4.34315 13 6 13C7.65685 13 9 14.3431 9 16M9 21H15M9 16C9 14.3431 10.3431 13 12 13C13.6569 13 15 14.3431 15 16M15 21V16M15 21H21V16C21 14.3431 19.6569 13 18 13C16.3431 13 15 14.3431 15 16","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 3C14.7614 3 17 5.23858 17 8V9H7V8C7 5.23858 9.23858 3 12 3ZM12 3V2M3 9H21V21H3V9Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Castle7Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'castle-7',
    ref,
    icon: element,
  },
));

Castle7Icon.displayName = 'Castle7Icon';

export default Castle7Icon;
